<template>
    <div class="saas-feature section-space--ptb_90 bg-gray">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center section-space--mb_60">
                        <h2 class="font-weight--light mb-15 wow move-up">Un ecosistema di moduli per una gestione completa.</h2>
                        <span class="section-text wow move-up">Questi sono i moduli che costituiscono l'applicazione Simple Service.</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
                    <div class="service-grid">
                        <div class="ht-service-box--one style-03">
                            <router-link :to="'branding'">
                                <div class="image__media">
                                    <img :src="item.icon" class="img-fluid">
                                </div>
                                <div class="content">
                                    <h6 class="heading">{{ item.heading }}</h6>
                                    <div class="service_text">{{ item.text }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SassFeature',
        data (){
            return {
                items: [
                    {
                        icon: require('../assets/img/icons/aeroland-box-image-02.png'), 
                        heading: 'Anagrafiche', 
                        text: 'Una completa gestione dei dati anagrafici dei vostri clienti, impianti, contratti, commesse e documenti.'
                    },                    
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-05.png'), 
                        heading: 'Gestione segnalazioni', 
                        text: "Questo modulo permette di gestire le segnalazioni di guasti o interventi ricevuti via email, telefono o fatti direttamente dall' amministratore di condominio o dal cliente finale."
                    },
                    {
                        icon: require('../assets/img/icons/landing-feasture-image-06.png'), 
                        heading: 'Pianificazione attività.', 
                        text: "Permette la programmazione degli interventi attraverso un calendario con viste giornaliere, settimanali o mensili e permette di avere in tempo reale un riscontro da parte del personale tecnico."
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-payment-box-icon-05.png'), 
                        heading: 'Rapportini digitali', 
                        text: 'Creazione automatica di rapportini di intervento con possibilità di firma da parte del cliente.'
                    },
                    {
                        icon: require('../assets/img/icons/checklist.png'), 
                        heading: 'Lista interventi predefiniti e listini.', 
                        text: 'Possibilità di definire una lista di interventi predefiniti, anche in base alla tipologia di impianto, e relativi listini.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-payment-box-icon-06.png'), 
                        heading: 'Rilevazione presenze', 
                        text: "Utile per l'elaborazione del cedolino paga, questo modulo permette la registrazione delle presenze e la richiesta di ferie o permessi. E' possibile l'esportazione dei dati su un foglio di calcolo."
                    },
                    {
                        icon: require('../assets/img/icons/warehouse.png'), 
                        heading: 'Gestione magazzino', 
                        text: "Carico magazzino con archivio bolle e fatture, scarico magazzino e calcolo giacenze."
                    },
                    {
                        icon: require('../assets/img/icons/calendar.png'), 
                        heading: 'Manutenzioni ordinarie', 
                        text: "In base al contratto e alla tipologia dell'impianto, questo modulo permette di automatizzare la pianificazione delle attività riguardanti gli interventi di manutenzione ordinaria."
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-box-image-04.png'), 
                        heading: 'Integrazione contabilità e fatturazione', 
                        text: "L'integrazione con il vostro sistema di contabilità permette di automatizzare il processo di creazione di ordini o fatture e un costante monitoraggio dei crediti."
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-box-image-06.png'), 
                        heading: 'Reports', 
                        text: 'Creazione di report dettagliati per commessa e cliente con riepilogo costi e ore lavorate per ciascun tecnico.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-payment-box-icon-04.png'), 
                        heading: 'Portale clienti', 
                        text: 'Questo modulo permette ai tuoi clienti di poter consultare i loro dati, scaricare documenti (fatture, contratti), segnalare guasti o fare richieste di intervento. Un canale diretto per una maggiore gestione e fidelizzazione del cliente.'
                    },
                    {
                        icon: require('../assets/img/icons/motorcycle.png'), 
                        heading: 'Moduli personalizzati', 
                        text: 'Grazie al sistema modulare e flessibile di Simple Service è sempre possibile sviluppare ed integrare nuovi moduli su specifica richiesta del cliente.'
                    },
                ]
            }
        }
    }
</script>
